// extracted by mini-css-extract-plugin
module.exports = {"container":"CouponTab_container__3Xx-N","couponContainer":"CouponTab_couponContainer__DwMnN"};